var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.5V9.63049C16.5 9.22213 16.4167 8.81807 16.2551 8.44304C16.0935 8.06802 15.8571 7.72993 15.5602 7.44949L10.0305 2.22349C9.752 1.96019 9.38327 1.81348 9 1.81348C8.61673 1.81348 8.248 1.96019 7.9695 2.22349L2.43975 7.44949C2.14292 7.72993 1.90646 8.06802 1.74487 8.44304C1.58328 8.81807 1.49996 9.22213 1.5 9.63049V15.5C1.5 15.8978 1.65804 16.2793 1.93934 16.5607C2.22064 16.842 2.60218 17 3 17H15C15.3978 17 15.7794 16.842 16.0607 16.5607C16.342 16.2793 16.5 15.8978 16.5 15.5Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2bb55c1379555d9cf329a01e8782cd4a.svg";
export { ForwardRef as ReactComponent };